import type { PropsWithChildren } from 'react'

import styles from './AudioDetailsLayout.module.css'

type TAudioDetailsLayoutProps = PropsWithChildren

export const AudioDetailsLayout = ({ children }: TAudioDetailsLayoutProps) => (
    <div className={styles.layout}>{children}</div>
)
